import React, { useState, useEffect } from "react";
import {getEmetteurs, getISINs, getSimulationDetails} from "../services/SimulatorService";
import { TranslationService } from "../services/TranslationService";

import { FormBuilder } from "./FormBuilder"
import { BondFormBuilderDetails } from "./BondFormBuilderDetails";

import Swal from 'sweetalert2';


const BondSimulatorInput = ({formData, updateFormData, clearFormData, resetIsins, setResetIsins, lang}) => {
  const [emetteurs, setEmetteurs] = useState([]);
  const [emetteur, setEmetteur] = useState();

  const [isins, setIsins] = useState([]);
  const [isin, setIsin] = useState();
 
  useEffect(() => {
    const fetchData = async () => {
      clearFormData();
      setEmetteurs(await getEmetteurs());
    };

    fetchData();
  }, []);

  useEffect(() => {
    if(resetIsins){
      setEmetteur({});
      setIsin({});
      setResetIsins(false);
    }
  }, [resetIsins]);

  const onEmetteurChange = async (event) => {
    const newEmetteur = event.target.value;
    setEmetteur(newEmetteur);
    setIsins(await getISINs(newEmetteur, "BAT"));
  };

  const onIsinChange = async (event) => {
    const newIsin = event.target.value;

    clearFormData();
    setIsin(newIsin);

    let details = await getSimulationDetails(newIsin)
    details.coupon = "";
    updateFormData(details);
    onDateBlur({target: {name: "dateEcheance", value: details.dateEcheance}})
  };

  const onDateBlur = (event) => {
    const { name, value } = event.target;
    let lowerDate, upperDate;
    if(name === "dateValeur"){
      lowerDate = value;
      upperDate = formData.dateEcheance;
    }else{
      lowerDate = formData.dateValeur;
      upperDate = value;
    }

    if(lowerDate >= upperDate){
      //setDatesInputError(TranslationService.translate("datesInputErrorMessage", lang),)
      showAlert();
    }
  };

  const onFormChange = (event) => {
    const { name, value } = event.target;
    let newValue = {[name]: value };
    updateFormData(newValue);
  };

  const formDetails = BondFormBuilderDetails ({
    emetteur,
    emetteurs,
    onEmetteurChange,
    isin,
    isins,
    onIsinChange,
    formData,
    onFormChange,
    onDateBlur,
    lang
  })

  const showAlert = () => {
    Swal.fire({
      text: TranslationService.translate("datesInputErrorMessage", lang),
      icon: 'error',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#3085d6', // Change the color of the "OK" button
    });
  };

  return (
    <>
    <div>
      {formDetails.map((field, index) => (FormBuilder.buildFieldGroup(field, index, lang)))}
    </div>
    </>
  );  
};

export default BondSimulatorInput;